import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import { CRM_STATUS_CONFIG } from "app/pages/sales-intelligence/modules/manage-integrations/constants/crm";
import type { ApiPageType } from "app/pages/sales-intelligence/modules/manage-integrations/types/api-page-type";
import type { RequestAdminFeatureBase } from "app/pages/sales-intelligence/types/requestAdminFeature";

type GatewayFeatureName = ApiPageType | RequestAdminFeatureBase;

export function isCrmGatewayFeatureName(
    featureName: GatewayFeatureName,
): featureName is CrmIntegrationProvider {
    return featureName in CRM_STATUS_CONFIG;
}
